import { tabsAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

import { DISABLED_OPACITY } from "../consts/other-consts";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  tabsAnatomy.keys
);

export const HOVER_FONT_WEIGHT_TAB = "semibold";

const baseStyle = definePartsStyle({
  tablist: {
    display: "flex",
    rounded: "base",
    alignItems: "flex-start",
    // You have to explicitely overwrite all the borders like this otherwise it doesnt work
    border: "1px solid !important",
    borderBottomColor: "brand.border !important",
    borderLeftColor: "brand.border !important",
    borderRightColor: "brand.border !important",
    borderTopColor: "brand.border !important",
    gap: "10px",
    padding: 0.5,
    color: "brand.analytic",
  },
  tab: {
    h: "button",
    bg: "none",
    border: "none",
    fontWeight: "light",
    borderWidth: 0.5,
    px: "4 !important",
    lineHeight: 4,
    transition: "all 0.4s",
    _hover: {
      color: "brand.analytic",
      fontWeight: HOVER_FONT_WEIGHT_TAB,
    },
    _selected: {
      border: "none",
      fontWeight: HOVER_FONT_WEIGHT_TAB,
    },

    _disabled: {
      opacity: DISABLED_OPACITY,
      fontWeight: "initial !important",
      color: "brand.grey.600 !important",
    },
  },
  tabpanel: {
    padding: 0,
    marginTop: 10,
  },
});

export const tabsTheme = defineMultiStyleConfig({ baseStyle });
